export default "__VITE_ASSET__EhxOTCji__"